import { render, staticRenderFns } from "./feedback_admin_comment.vue?vue&type=template&id=f0d3f178&"
import script from "./feedback_admin_comment.vue?vue&type=script&lang=js&"
export * from "./feedback_admin_comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports